import apiReq from '../commontools/api.js'
export function PayMOrderByAli(mobile,orderid,goodsname,amount){
	var url='/AliPay/PayMOrderByAli/'+mobile+'/'+orderid+'/'+goodsname+'/'+amount;
	return apiReq.get(apiReq.defaults.baseURL2+ url);
}
export function QueryByAli(orderid){
	var url='/AliPay/QueryByAli/'+orderid;
	return apiReq.get(apiReq.defaults.baseURL2+ url);
}
export function RefundByAli(orderid, amount, isAll, chargeno){
	if(isAll)
	{
		var url='/AliPay/RefundAllByAli/'+orderid+'/'+amount;
	return apiReq.get(apiReq.defaults.baseURL2+ url);
	}
	else
	{
		var url='/AliPay/RefundPartByAli/'+orderid+'/'+amount+'/'+chargeno;
		return apiReq.get(apiReq.defaults.baseURL2+ url);
	}
	
}
export function PayOrderCusByAli(cusid,orderid, ChargeCash){
	var url='/AliPay/PayOrderCusByAli/'+cusid+'/'+orderid+'/'+ChargeCash;
	return apiReq.get(apiReq.defaults.baseURL2+ url);
}
export default{
	PayMOrderByAli,
	QueryByAli,
	RefundByAli,
	PayOrderCusByAli
	}